import { Injectable } from '@angular/core';
import { DataResponseHttp } from '../../../http-models/data-response.http';
import { DataResponseModel } from '../../../models/apis/data-response.model';
import { BaseMapper } from '../../base.mapper';
import { NotificationInfoModel } from '../../../models/apis/system/notification/notification-info.model';
import { NotificationInfoHttp } from '../../../http-models/systems/notification/notification-info.http';

@Injectable({
    providedIn: 'root',
})
export class GetNotificationInfoMapper
    implements
    BaseMapper<DataResponseModel<NotificationInfoModel>, DataResponseHttp<NotificationInfoHttp>>
{

    convertFrom(
        http: DataResponseHttp<NotificationInfoHttp>
    ): DataResponseModel<NotificationInfoModel> {

        let response = {
            isError: http.isError,
            errors: http.errors,
            data: {...http.data}
        } as DataResponseModel<NotificationInfoModel>;

        return response;
    }
}
